// import * as dayjs from 'dayjs';
// import dayjs from 'dayjs';

export const FormatDistanceNumber = (theNumber?: number, locale = 'en-AU') => {
    if (theNumber) {
        // const round
        const rounded = Math.ceil(theNumber);
        return new Intl.NumberFormat(locale).format(rounded);
    }
    return null;
};

export const AusPhoneRegex = /^(\+61|0)?[0-9]{9}$/;

export const ValidateAusPhone = (phoneNumber: string): boolean => AusPhoneRegex.test(phoneNumber);

// export const ShortDateFromFullDateTime = (fulldatetime: string) => dayjs(fulldatetime, 'M/D/YYYY hh:mm:ss A').format('D MMM YYYY');

export default { FormatDistanceNumber, AusPhoneRegex, ValidateAusPhone };
